import { usePageDataContext } from '~/context/PageData';
import Blocks from '../Page/Blocks';
import classNames from 'classnames';

export interface VariationProps {
  className?: string;
  isActive?: boolean;
  isBodyElement?: boolean;
}

export function Variation({
  pageBlock,
  pageBlocks,
  className,
  isActive,
  isBodyElement
}: any) {
  const { sys, fields } = pageBlock ?? {};
  const { page } = usePageDataContext();

  if (!isActive) {
    return null;
  }

  return (
    <div
      className={classNames(`${className}`, {
        'mb-20 flex w-full flex-col gap-y-20 tablet:mb-[120px] tablet:gap-y-[120px]':
          isBodyElement
      })}
    >
      <Blocks
        sys={sys}
        fields={fields}
        isActive={isActive}
        seoProps={{
          page,
          pageBlock
        }}
      />
      {pageBlocks?.map((block: any) => (
        <section
          key={block.sys?.id}
          data-cfid={block.sys?.id}
          data-testid="page-block"
          className={classNames({
            '-my-10 tablet:-my-[60px]':
              block.sys?.contentType?.sys?.id === 'bodyCopy'
          })}
        >
          <Blocks
            sys={block.sys}
            fields={block.fields}
            isActive={isActive}
            seoProps={{
              page,
              block
            }}
          />
        </section>
      ))}
    </div>
  );
}
